import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function wholeNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valid = /^[0-9]$|^([1-9][0-9]*)$/.test(control.value);
    return !valid ? { notWholeNumber: { value: control.value, msg: 'Hodnota nie je celé číslo.' } } : null;
  };
}
